/* eslint-disable import/no-default-export */
import { createPrefixer } from '.'

const ROOT = 'ver-persona-pg' as const
export const RESOURCE_PERSONA = 'Persona PG' as const
const rp = <T extends string>(mod: T): `${typeof ROOT}-${T}` => `${ROOT}-${mod}`
const pm = createPrefixer(ROOT, 'mantenimiento')
const pt = createPrefixer(ROOT, 'transacciones')
const pc = createPrefixer(ROOT, 'configuracion')
const pi = createPrefixer(ROOT, 'informes')

const permission = {
    _root: ROOT,
    _resource: RESOURCE_PERSONA,
    dashboard: {
        _perm: rp('dashboard'),
    },
    mantenimiento: {
        _perm: rp('mantenimiento'),
        entidades: pm('entidades'),
        registrarEntidad: pm('registrar-entidad'),
        proveedor: pm('proveedor'),
        registrarProveedor: pm('registrar-proveedor'),
    },
    configuracion: {
        _perm: rp('configuracion'),
        permisoCategoriaEntidad: pc('permiso-categoria-entidad'),
    },
    transacciones: {
        _perm: rp('transacciones'),
        aprobacionProveedor: pt('aprobacion-proveedor'),
    },
    informes: {
        _perm: rp('informes'),
        informeProveedorPorCuenta: pi('entidades-x-establecimiento'),
    },
}
export default permission
